import deleteRequest from '../../../../deleteRequest';

/**
 * Deletes size map.
 *
 * @param {string} swatchColourIdsString
 * @param {string} colourGroupName
 * @param {number} languageId
 * @returns {Promise} { Success: true }, status: 200 }
 */
async function deleteSwatchColours(colourGroupName, languageId, swatchColourIdsString) {
  const endpoint = `/oc-data-management/v1/colourMatching/deleteColours/${languageId}`;
  const body = {
    colourGroupName,
    swatchColourIdsString,
  };

  return new Promise((resolve, reject) => {
    deleteRequest(endpoint, body)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default deleteSwatchColours;
